import { useEffect } from "react";

import { Button, isLoggedIn, Modal, useManagedModal } from "@shapr3d/frontend-lib";

import addCommentIcon from "../../assets/images/add-comment-icon.svg";
import { useKeyboardHandle } from "../../hooks/useKeyboardHandle";
import { useMouseHandle } from "../../hooks/useMouseHandle";
import { useCommentsStore } from "../../stores/commentStore";
import { navigateToAuth } from "../../utils/authUtils";
import { ToolButton } from "../ToolButton/ToolButton";

import style from "./Toolbar.module.css";

export const Toolbar = () => {
  const { isInAddCommentMode, toggleIsInAddCommentMode } = useCommentsStore();
  useKeyboardHandle();
  useMouseHandle();
  const loginModal = useManagedModal();

  useEffect(() => {
    if (isInAddCommentMode && !isLoggedIn()) {
      loginModal.open();
      toggleIsInAddCommentMode({ source: "tool_menu" });
    }
  }, [isInAddCommentMode, loginModal, toggleIsInAddCommentMode]);

  const handleAddComment = () => {
    if (!isLoggedIn()) {
      loginModal.open();
    } else {
      toggleIsInAddCommentMode({ source: "tool_menu" });
    }
  };

  return (
    <div className={style.wrapper}>
      <ToolButton
        title="Add Comment (Ctrl+Shift+click)"
        alt="Add Comment"
        icon={addCommentIcon}
        onClick={() => handleAddComment()}
        shouldShowLabel
        isActive={isInAddCommentMode}
        label="Add Comment"
        activeLabel="Place Comment"
      />

      <Modal {...loginModal.props} size="small" title="You need to log in to add a comment">
        <div className={style.modalContainer}>
          <div className={style.modalText}>
            You are about to leave this page to log in or sign up.
          </div>
          <Button variant="primary" onClick={() => navigateToAuth()} className={style.button}>
            Log in
          </Button>
        </div>
      </Modal>
    </div>
  );
};
